// src/components/BookingStrip.jsx - Barra de reserva Omnibees (hotel 5894)
import React, { useContext, useEffect, useRef, useState } from 'react';
import { ConfigContext } from '../contexts/ConfigContext';
import '../styles/booking-strip.css';

const HOTEL_ID = 5894; // ID do hotel no Omnibees

const pad = (n) => (n < 10 ? '0' : '') + n;
const iso = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
// Converte "2025-08-15" (valor do input) para "15082025" sem usar new Date (evita erro de fuso -1)
const fmtISO = (v) => {
  const p = v.split('-');
  return `${p[2]}${p[1]}${p[0]}`;
};
const addDays = (isoValue, days) => {
  const p = isoValue.split('-').map(Number);
  const d = new Date(p[0], p[1] - 1, p[2]);
  d.setDate(d.getDate() + days);
  return iso(d);
};

function BookingStrip() {
  const { config } = useContext(ConfigContext);
  const stripRef = useRef(null);

  const today = iso(new Date());
  const [checkIn, setCheckIn] = useState(today);
  const [checkOut, setCheckOut] = useState(addDays(today, 1));
  const [rooms, setRooms] = useState('1');
  const [adults, setAdults] = useState('2');
  const [code, setCode] = useState('');
  const [top, setTop] = useState(0);
  const [hidden, setHidden] = useState(false);

  // Fica logo abaixo do header (que é sticky com altura variável)
  useEffect(() => {
    const header = document.querySelector('.header');
    const setTopValue = () => setTop(header ? header.offsetHeight : 0);
    setTopValue();
    window.addEventListener('resize', setTopValue);
    window.addEventListener('scroll', setTopValue);
    return () => {
      window.removeEventListener('resize', setTopValue);
      window.removeEventListener('scroll', setTopValue);
    };
  }, []);

  // Esconde a barra quando o menu mobile está aberto
  useEffect(() => {
    const sync = () => setHidden(document.body.classList.contains('menu-open'));
    sync();
    const mo = new MutationObserver(sync);
    mo.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    return () => mo.disconnect();
  }, []);

  const minCheckOut = addDays(checkIn, 1);
  const nightsCount = Math.round(
    (new Date(`${checkOut}T00:00:00`) - new Date(`${checkIn}T00:00:00`)) / 86400000
  );

  const handleCheckIn = (value) => {
    setCheckIn(value);
    if (checkOut <= value) setCheckOut(addDays(value, 1));
  };

  const handleCheckOut = (value) => {
    setCheckOut(value <= checkIn ? addDays(checkIn, 1) : value);
  };

  const handleSearch = () => {
    const params = [
      `q=${HOTEL_ID}`,
      'lang=pt-BR',
      `NRooms=${rooms}`,
      `ad=${adults}`,
      `CheckIn=${fmtISO(checkIn)}`,
      `CheckOut=${fmtISO(checkOut)}`,
    ];
    const c = code.trim();
    if (c) params.push(`Code=${encodeURIComponent(c)}`);
    window.open(`https://book.omnibees.com/hotelresults?${params.join('&')}`, '_blank');
  };

  const styles = {
    top: `${top}px`,
    display: hidden ? 'none' : undefined,
    '--strip-btn-color': config.header_bg_color || '#0d9488',
  };

  return (
    <div id="booking-strip" ref={stripRef} style={styles}>
      <div className="bs-inner">
        <div className="bs-field bs-dates">
          <label htmlFor="bs-checkin">
            Check-in / Check-out{' '}
            <span className="bs-nights">
              {nightsCount > 0 ? `${nightsCount} ${nightsCount > 1 ? 'Noites' : 'Noite'}` : ''}
            </span>
          </label>
          <div className="bs-row">
            <input
              type="date"
              id="bs-checkin"
              value={checkIn}
              min={today}
              onChange={(e) => handleCheckIn(e.target.value)}
            />
            <input
              type="date"
              id="bs-checkout"
              value={checkOut}
              min={minCheckOut}
              onChange={(e) => handleCheckOut(e.target.value)}
            />
          </div>
        </div>

        <div className="bs-field bs-guests">
          <label htmlFor="bs-rooms">Quartos e hóspedes</label>
          <div className="bs-row">
            <select id="bs-rooms" title="Quartos" value={rooms} onChange={(e) => setRooms(e.target.value)}>
              {[1, 2, 3, 4].map((n) => (
                <option key={n} value={n}>{n} {n > 1 ? 'quartos' : 'quarto'}</option>
              ))}
            </select>
            <select id="bs-adults" title="Hóspedes" value={adults} onChange={(e) => setAdults(e.target.value)}>
              {[1, 2, 3, 4, 5, 6].map((n) => (
                <option key={n} value={n}>{n} {n > 1 ? 'hóspedes' : 'hóspede'}</option>
              ))}
            </select>
          </div>
        </div>

        <div className="bs-field bs-code">
          <label htmlFor="bs-code">Tenho um código</label>
          <input
            type="text"
            id="bs-code"
            placeholder="Meu código"
            value={code}
            onChange={(e) => setCode(e.target.value)}
          />
        </div>

        <div className="bs-field bs-btn">
          <button type="button" id="bs-search" onClick={handleSearch}>Buscar</button>
        </div>
      </div>
    </div>
  );
}

export default BookingStrip;
